import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import {
  FaBuilding,
  FaHardHat,
  FaShieldAlt,
  FaTruck,
  FaClock,
  FaAward,
  FaArrowRight,
  FaCheck,
} from "react-icons/fa";
import heroImage2 from '../assets/images/bannertest3.jpg';
import about from '../assets/images/bannertest.jpg';
import school from '../assets/images/school.png';
import shell from '../assets/images/shell.png';
import tinyhouse from '../assets/images/tiny-house.png';
import universiteit from '../assets/images/universiteit.png';
import villa from '../assets/images/villa.png';
import zwembad from '../assets/images/zwembad.png';
import { useTranslation } from "react-i18next"
import { Helmet } from "react-helmet-async";



function Home() {
  const { t, i18n } = useTranslation();
  const features = t('home.about.features', { returnObjects: true }); // This will return the array
  const currentLang = i18n.language
  return (
    <>
      <Helmet>
        <title>{t("seo.home.title")}</title>
        <meta name="description" content={t("seo.home.description")} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`${window.location.origin}/${currentLang}/`} />
        
        <meta property="og:title" content={t("seo.home.title")} />
        <meta property="og:description" content={t("seo.home.description")} />
        <meta property="og:url" content={`${window.location.origin}/${currentLang}/`} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t("seo.home.title")} />
        <meta name="twitter:description" content={t("seo.home.description")} />
        <meta name="twitter:image" content="path/to/your/image.jpg" />
      </Helmet>

      {/* Hero Section */}
      <section
        className="hero-section"
        style={{ backgroundImage: `url(${heroImage2})` }}
      >
        <Container>
          <div className="hero-content">
            <h1>
              {t("home.landing.title1")}{" "}
              <span className="text-tertiary">{t("home.landing.title2")}{" "}</span>
            </h1>
            <p>
              {t("home.landing.undertitle")}{" "}
            </p>
            <div className="btn-group">
                <Button variant="tertiary" size="lg" className="btn-home" as={Link}  to={`/${currentLang}/contact`}>
                  {t("home.landing.buttonQuote")}{" "}
                </Button>
                <Button variant="outline-light" size="lg" className="" as={Link}  to={`/${currentLang}/projects`}>
                  {t("home.landing.buttonProjects")}{" "}
                </Button>
            </div>
          </div>
        </Container>
      </section>

      {/* Services Preview */}
      <section className="services-section section-padding">
        <Container>
          <div className="text-center mb-5">
            <h2 className="mb-3">{t("home.services.title")}{" "}</h2>
            <p className="text-secondary mx-auto" style={{ maxWidth: "700px" }}>
              {t("home.services.undertitle")}{" "}
            </p>
          </div>

          <Row className="g-4">
            {[
              {
                icon: <FaBuilding />,
                title: t("home.services.shellConstruction.title"),
                description:
                t("home.services.shellConstruction.description"),
              },
              {
                icon: <FaHardHat />,
                title: t("home.services.foundationWork.title"),
                description:
                  t("home.services.foundationWork.description"),
              },
              {
                icon: <FaShieldAlt />,
                title: t("home.services.concreteStructures.title"),
                description:
                  t("home.services.concreteStructures.description"),
              },
              {
                icon: <FaTruck />,
                title: t("home.services.industrialConstruction.title"),
                description:
                  t("home.services.industrialConstruction.description"),
              },
              {
                icon: <FaClock />,
                title: t("home.services.renovation.title"),
                description:
                  t("home.services.renovation.description"),
              },
              {
                icon: <FaAward />,
                title: t("home.services.projectManagement.title"),
                description:
                  t("home.services.projectManagement.description"),
              },
            ].map((service, index) => (
              <Col key={index} md={6} lg={4}>
                <Card className="card-service h-100">
                  <Card.Body>
                    <div className="card-icon">{service.icon}</div>
                    <Card.Title>{service.title}</Card.Title>
                    <Card.Text>{service.description}</Card.Text>
                    <Link to={`/${currentLang}/services`} className="card-link">
                    {t("common.learnMore")}{" "}
                    <FaArrowRight size={12} className="ms-1" />
                    </Link>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* About Preview */}
      <section className="about-preview-section section-padding">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <div style={{ height: "500px", position: "relative" }}>
                <img
                  src={about || "/placeholder.svg"}
                  alt="About Betonbum"
                  className="img-cover rounded"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                  loading="lazy"
                />
              </div>
            </Col>

            <Col lg={6}>
              <h2>{t("home.about.title")}{" "}</h2>
              <p className="text-secondary mb-4">
                {t("home.about.description")}{" "}
              </p>

              <ul className="feature-list mb-4">
                {features.map((item, index) => (
                  <li key={index}>
                    <FaCheck className="icon" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <Button as={Link} variant="primary" to={`/${currentLang}/about`} size="lg">
              {t("common.learnMore")}{" "}
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Projects Preview */}
      <section className="projects-section section-padding bg-light">
        <Container>
          <div className="text-center mb-5">
            <h2 className="mb-3">{t("home.projects.title")}{" "}</h2>
            <p className="text-secondary mx-auto" style={{ maxWidth: "700px" }}>
              {t("home.projects.undertitle")}{" "}
            </p>
          </div>

          <Row className="g-4">
            {[
              {
                image: school,
                title: t("home.projects.school.title"),
                category: t("home.projects.school.category"),
              },
              {
                image: shell,
                title: t("home.projects.luxuryHouse.title"),
                category: t("home.projects.luxuryHouse.category"),
              },
              {
                image: tinyhouse,
                title: t("home.projects.tinyHouse.title"),
                category: t("home.projects.tinyHouse.category"),
              },
              {
                image: universiteit,
                title: t("home.projects.center.title"),
                category: t("home.projects.center.category"),
              },
              {
                image: villa,
                title: t("home.projects.house.title"),
                category: t("home.projects.house.category"),
              },
              {
                image: zwembad,
                title: t("home.projects.swimming.title"),
                category: t("home.projects.swimming.category"),
              },
            ].map((project, index) => (
              <Col key={index} md={6} lg={4}>
                <Card className="card-project">
                  <div style={{ height: "250px", overflow: "hidden" }}>
                    <Card.Img
                      variant="top"
                      src={project.image}
                      alt={project.title}
                      className="img-cover"
                      style={{ height: "100%" }}
                      loading="lazy"
                    />
                  </div>
                  <Card.ImgOverlay>
                    <div className="project-category">{project.category}</div>
                    <h5 className="project-title">{project.title}</h5>
                  </Card.ImgOverlay>
                </Card>
              </Col>
            ))}
          </Row>

          <div className="text-center mt-5">
            <Button as={Link} to={`/${currentLang}/projects`} variant="primary" size="lg">
            {t("common.viewProjects")}{" "}
            </Button>
          </div>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="cta-section section-padding">
        <Container>
          <div className="cta-content">
            <h2>{t("home.cta.title")}{" "}</h2>
            <p>
              {t("home.cta.description")}{" "}
            </p>
            <div className="d-flex justify-content-center gap-3 flex-wrap">
              
              <Button variant="tertiary" size="lg" as={Link} to={`/${currentLang}/contact`}>
                {t("home.cta.buttonQuote")}{" "}
              </Button>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}

export default Home;
